"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    selectRoot: {
      display: 'flex',
      alignItems: 'center',
      padding: 0,
      background: 'transparent',
      '&:focus': {
        background: 'transparent'
      }
    },
    icone: {
      color: theme.palette.primary.main,
      right: 0,
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      pointerEvents: 'none'
    },
    select: {
      paddingRight: 32,
      minWidth: 120
    },
    inputBase: {
      fontWeight: 700,
      fontSize: 24,
      color: theme.palette.primary.main,
      padding: '2px 32px 2px 0',
      minWidth: 100,
      cursor: 'pointer',
      border: 'none',
      background: 'transparent',
      lineHeight: 1.1
    }
  };
});
var SttSelect = function SttSelect(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    options = _ref.options;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'inline-block',
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Select, {
    value: value,
    onChange: onChange,
    input: /*#__PURE__*/_react["default"].createElement(_core.InputBase, {
      classes: {
        input: classes.inputBase
      }
    }),
    classes: {
      root: classes.selectRoot,
      select: classes.select,
      icon: classes.icone
    },
    IconComponent: _ExpandMore["default"],
    disableUnderline: true,
    MenuProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      getContentAnchorEl: null
    }
  }, options.map(function (options) {
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      key: options.key,
      value: options.key
    }, options.text);
  })));
};
var _default = SttSelect;
exports["default"] = _default;